import {createContext, type Dispatch} from 'react'
import {type TagsComponentState} from './types/tags-component-state'
import {type AllActions} from './state/actions'
import {DEFAULT_TAG_COMPONENT_STATE} from './types/default-tag-component-state'

export const TagsComponentContext = createContext<{
    state: TagsComponentState
    dispatch: Dispatch<AllActions> | undefined
}>({state: DEFAULT_TAG_COMPONENT_STATE, dispatch: undefined})
